export const NAV_CONST = {
  dashBoard: '대시보드',
  serviceOperation: '서비스 운영',
  systemManagement: '시스템 관리',
  customersManagement: '회원관리',
  normalCustomersManagement: '개인 회원 관리',
  normalCustomersDetail: '개인 회원 상세',
  businessCustomersManagement: '사업자 회원 관리',
  businessCustomersDetail: '사업자 회원 상세',
  recyclingManagement: '수거 관리',
  recyclingProductManagement: '수거 품목 관리',
  recyclingProductAdd: '수거 품목 등록',
  recyclingProductEdit: '수거 품목 수정',
  recyclingProductDetail: '수거 품목 상세',
  recyclingCouponManagement: '배송비 쿠폰 관리',
  recyclingRequests: '수거 신청 관리',
  recyclingRequestsDetail: '수거 신청 상세',
  recyclingPackageProducts: '수거 기본 품목 관리',
  pushAlarmInfoManagement: '푸시 알림 관리',
  pushAlarmInfoDetail: '푸시 알림 상세',
  pushAlarmInfoEdit: '푸시 알림 수정',
  pushAlarmInfoAdd: '푸시 알림 등록',
  marketing: '마케팅',
  mainBanner: '메인 배너 관리',
  mainBannerManagement: '메인 배너 관리',
  mainBannerAdd: '메인 배너 등록',
  mainBannerDetail: '메인 배너 상세',
  mainBannerEdit: '메인 배너 수정',
  subBanner: '서브 배너 관리',
  subBannerManagement: '서브 배너 관리',
  subBannerAdd: '서브 배너 등록',
  subBannerDetail: '서브 배너 상세',
  subBannerEdit: '서브 배너 수정',
  partnershipCompanies: '제휴사 관리',
  partnershipLink: '제휴사 링크 관리',
  notice: '공지사항',
  noticeManagement: '공지사항 관리',
  noticeAdd: '공지사항 등록',
  noticeDetail: '공지사항 상세',
  noticeEdit: '공지사항 수정',
  inquiry: '1:1 문의',
  inquiryManagement: '1:1 문의 관리',
  inquiryDetail: '1:1 문의 상세',
  faq: 'FAQ',
  faqManagement: 'FAQ 관리',
  faqAdd: 'FAQ 등록',
  faqDetail: 'FAQ 상세',
  faqEdit: 'FAQ 수정',
  supportCustomer: '고객 지원',
  administrator: '관리자',
  administratorCreate: '관리자 등록',
  administratorManagement: '관리자 관리',
  administratorDetail: '관리자 상세',
  administratorModify: '관리자 수정',
  earthCredit: '얼스 크레딧',
  credit: '크레딧',
  creditManagement: '얼스 크레딧 내역',
  content: '컨텐츠',
  magazineManagement: '매거진 관리',
  magazineCreate: '매거진 등록',
  magazineDetail: '매거진 상세',
  magazineEdit: '매거진 수정',
  community: '커뮤니티',
  communityManagement: '커뮤니티 관리',
  communityDetail: '커뮤니티 상세',
  communityReportManagement: '신고 접수 관리',
  communityReportDetail: '신고 접수 상세',
  entry: '응모하기',
  entryManagement: '응모하기 관리',
  entryCreate: '응모하기 등록',
  entryEdit: '응모하기 수정',
  entryDetail: '응모하기 상세',
  donation: '기부하기',
  donationManagement: '기부하기 관리',
  donationCreate: '기부하기 등록',
  donationDetail: '기부하기 상세',
  donationEdit: '기부하기 수정',
  challenge: '챌린지',
  challengeManagement: '챌린지 관리',
  challengeCreate: '챌린지 등록',
  challengeDetail: '챌린지 상세',
  challengeEdit: '챌린지 수정',
};
